import { useToDoStatusesQuery } from "src/components/to-dos/ToDosBoard.generated";
import { ToDoStatus, ToDoStatusDetail } from "src/generated/graphqlTypes";

export function useToDoStatuses(): ToDoStatusDetail[] {
  const statusesQuery = useToDoStatusesQuery({ fetchPolicy: "cache-first" });

  return (
    statusesQuery.data?.toDoStatuses ??
    Object.values(ToDoStatus).map((code, sortOrder) => ({ code, name: code.replace(/_/g, " "), sortOrder }))
  );
}
